export enum DocumentRequestModuleType {
  TNS = 'tns',
  RESULT_ALLOCATION = 'result_allocation',
  LEASING = 'leasing',
  STOCK = 'stock',
  CUSTOM = 'custom'
}
